class FooterMobileMenu extends HTMLElement {
    constructor() {
        super();
        this.footerAccordions = document.querySelectorAll( ".component--footer--menu-accordions__tab" );
        this.bindEvents();
    }
    bindEvents() {
        this.footerAccordions.forEach( accordion => accordion.addEventListener( 'click', this.toggleFooterAccordion.bind(this) ) );
    }
    toggleFooterAccordion (event) {
        const element = event.currentTarget;
        const itemToggle = element.getAttribute( 'aria-expanded' );
        for (let i = 0; i < this.footerAccordions.length; i++ ) {
            this.footerAccordions[i].setAttribute( 'aria-expanded', 'false' );
        }
        if ( itemToggle == 'false' ) {
            element.setAttribute( 'aria-expanded', 'true' );
        }
    }
}
customElements.define('footer-mobile-menu', FooterMobileMenu);
class FooterNewsletter extends HTMLElement {
    constructor() {
        super();
        this.defaults = {
            newsletter: "[data-footer-newsletter-form]",
            newsletterInput: '.component--footer--newsletter__input',
            newsletterInputField: '.component--footer--newsletter__field',
            newsletterMessages: ".component--footer--newsletter__messages",
            successMessage: ".component--footer--newsletter__success-message",
            errorMessage: ".component--footer--newsletter__error-message"
        };
        this.newsletter = document.querySelector( this.defaults.newsletter );
        this.newsletterInput = document.querySelector( this.defaults.newsletterInput );
        this.newsletterInputField = document.querySelector( this.defaults.newsletterInputField );
        this.newsletterMessages = document.querySelector( this.defaults.newsletterMessages );
        this.newsletterSuccessMessage = document.querySelector( this.defaults.successMessage );
        this.newsletterErrorMessage = document.querySelector( this.defaults.errorMessage );
        this.bindEvents();
    }
    bindEvents() {
        this.newsletter.addEventListener( 'submit', this.submitForm.bind(this));
    }
    successMessages() {
        this.newsletterSuccessMessage.style.display = "block";
        this.newsletterErrorMessage.style.display = "none";
        this.newsletterInputField.style.display = "none";
    };
    errorMessages( ele, error ) {
        const html =
            `<svg width="12" height="12" viewBox="0 0 12 12" fill="#e2665c" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 0C2.6934 0 0 2.6934 0 6C0 9.3066 2.6934 12 6 12C9.3066 12 12 9.3066 12 6C12 2.6934 9.3066 0 6 0ZM6 1.2C8.65807 1.2 10.8 3.34193 10.8 6C10.8 8.65807 8.65807 10.8 6 10.8C3.34193 10.8 1.2 8.65807 1.2 6C1.2 3.34193 3.34193 1.2 6 1.2ZM5.4 3V4.2H6.6V3H5.4ZM5.4 5.4V9H6.6V5.4H5.4Z" />
            </svg>${error}`;
        ele.innerHTML = html;
        ele.style.display = "block";
        this.newsletterInput.style.border = "2px solid #e2665c";
    };
    resetForm() {
        this.newsletterSuccessMessage.style.display = "none";
        this.newsletterErrorMessage.style.display = "none";
        this.newsletterErrorMessage.innerHTML = "";
        this.newsletterInputField.style.display = "block";
    };
    validateEmail( email ) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test( String( email ).toLowerCase() );
    }
    subscribe(id, email) {
        const data = {
            g: id,
            email: email,
        }
        const urlData = new URLSearchParams(data)
        const url = "https://manage.kmail-lists.com/ajax/subscriptions/subscribe";
        fetch(url, {
            method: 'POST',
            async: true,
            crossDomain: true,
            body: urlData,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Cache-Control": "no-cache"
            }
        })
            .then(response => response.json())
            .then(res => {
                if ( res.success ) {
                    if ( res.data.is_subscribed ) {
                        this.errorMessages(
                            this.newsletterErrorMessage,
                            "This email address has already subscribed."
                        );
                    } else {
                        this.successMessages();
                    }
                } else {
                    this.errorMessages( this.newsletterErrorMessage, "Invalid Email Address." );
                }
            })
            .catch(err => {
                this.errorMessages( this.newsletterErrorMessage, "Something went wrong!" );
            })
    }
    submitForm(e) {
        e.preventDefault();
        const email = this.newsletter.elements['email'].value;
        const listId = this.newsletter.elements['g'].value;
        if ( email !== "" ) {
            if ( this.validateEmail( email ) ) {
                this.subscribe(listId, email);
            } else {
                this.errorMessages( this.newsletterErrorMessage, "Invalid Email Address." );
            }
        } else {
            this.errorMessages( this.newsletterErrorMessage, "Email Address Required." );
        }
        return false;
    }
}
customElements.define('footer-newsletter', FooterNewsletter);